function getCollectionVariantData(form) {
  const variantsScript =
    form.querySelector('script.product-variants-json') ||
    form.querySelector('script[type="application/json"]:not(.variant-discontinued-map)');
  const discontinuedScript = form.querySelector('script.variant-discontinued-map');

  if (!variantsScript) {
    return { variants: [], discontinuedMap: {} };
  }

  return {
    variants: JSON.parse(variantsScript.textContent),
    discontinuedMap: JSON.parse(discontinuedScript?.textContent || '{}'),
  };
}

function findPreferredCollectionVariant(form, variants, discontinuedMap) {
  const preferredId =
    form.dataset.selectedVariantId || form.querySelector('input[name="id"]')?.value;
  const preferred = preferredId
    ? variants.find((variant) => String(variant.id) === String(preferredId))
    : null;

  if (preferred && preferred.available && !discontinuedMap[preferred.id]) {
    return preferred;
  }

  if (preferred) {
    const availableVariants = variants.filter(
      (variant) => variant.available && !discontinuedMap[variant.id]
    );
    let bestMatch = null;
    let bestScore = -1;

    for (const candidate of availableVariants) {
      const score = candidate.options.reduce((total, optionValue, index) => {
        return total + (optionValue === preferred.options[index] ? 1 : 0);
      }, 0);

      if (score > bestScore) {
        bestScore = score;
        bestMatch = candidate;
      }
    }

    if (bestMatch) return bestMatch;
  }

  return (
    variants.find((variant) => variant.available && !discontinuedMap[variant.id]) ||
    preferred ||
    variants[0] ||
    null
  );
}

function updateCollectionAddButton(form, variant) {
  const submitButton = form.querySelector('.quick-add__submit');
  if (!submitButton) return;

  const buttonText = submitButton.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
  const soldOutMessage = submitButton.querySelector('.sold-out-message');
  const variantIdInput = form.querySelector('input[name="id"]');

  if (!variant) {
    if (buttonText) buttonText.classList.remove('hidden');
    if (soldOutMessage) soldOutMessage.classList.add('hidden');
    submitButton.disabled = true;
    submitButton.setAttribute('aria-disabled', 'true');
    return;
  }

  if (variantIdInput) {
    variantIdInput.value = variant.id;
    if (variant.available) {
      variantIdInput.removeAttribute('disabled');
    } else {
      variantIdInput.setAttribute('disabled', 'disabled');
    }
  }

  if (variant.available) {
    submitButton.disabled = false;
    submitButton.removeAttribute('aria-disabled');
    if (buttonText) {
      buttonText.textContent = 'Add to Bag';
      buttonText.classList.remove('hidden');
    }
    if (soldOutMessage) soldOutMessage.classList.add('hidden');
    return;
  }

  submitButton.disabled = true;
  submitButton.setAttribute('aria-disabled', 'true');
  if (buttonText) buttonText.classList.add('hidden');
  if (soldOutMessage) soldOutMessage.classList.remove('hidden');
}

function selectCollectionVariantOptions(form, variant) {
  if (!variant?.options) return;

  variant.options.forEach((optionValue) => {
    const escapedValue =
      window.CSS && typeof CSS.escape === 'function'
        ? CSS.escape(String(optionValue))
        : String(optionValue).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const matchingRadios = form.querySelectorAll(`input[type="radio"][value="${escapedValue}"]`);
    matchingRadios.forEach((radio) => {
      radio.checked = true;
    });
  });
}

function syncCollectionVariantForm(form) {
  const { variants, discontinuedMap } = getCollectionVariantData(form);
  if (!variants.length) return;

  const targetVariant = findPreferredCollectionVariant(form, variants, discontinuedMap);
  if (!targetVariant) return;

  form.dataset.selectedVariantId = String(targetVariant.id);
  selectCollectionVariantOptions(form, targetVariant);
  updateCollectionAddButton(form, targetVariant);
}

function collVariant() {
  document.querySelectorAll('.custom-product-form').forEach((form) => {
    try {
      syncCollectionVariantForm(form);
    } catch (error) {
      console.error('Error in collVariant for form:', error);
    }
  });
}

function initializeVariantSelections() {
  document.querySelectorAll('.custom-product-form').forEach((form) => {
    try {
      syncCollectionVariantForm(form);
    } catch (error) {
      console.error('Error in initializeVariantSelections for form:', error);
    }
  });
}

function initializeCardColorSwatches() {
  // Hide color selectors in quick-add forms when card has color swatches
  // Also add class to card-information when no color swatches for inline price/rating
  document.querySelectorAll('.card-wrapper').forEach(cardWrapper => {
    const cardInformation = cardWrapper.querySelector('.card-information');
    const hasColorSwatches = cardWrapper.querySelector('.card__color-swatches-wrapper');
    
    if (hasColorSwatches) {
      const colorSelectors = cardWrapper.querySelectorAll('.custom-product-form .size-select-inner.main-Colour, .custom-product-form .size-select-inner.main-Color');
      colorSelectors.forEach(selector => {
        selector.style.display = 'none';
      });
    } else if (cardInformation) {
      // Add class for browsers that don't support :has()
      cardInformation.classList.add('no-color-swatches');
    }
  });
  
  document.querySelectorAll('.card__color-swatch').forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      // Prevent navigation and stop propagation
      e.preventDefault();
      e.stopPropagation();
      
      const productId = this.getAttribute('data-product-id');
      const cardWrapper = this.closest('.card-wrapper');
      if (!cardWrapper) return false;
      
      // Find and prevent any parent links from navigating
      let parent = this.parentElement;
      while (parent && parent !== cardWrapper) {
        if (parent.tagName === 'A') {
          parent.addEventListener('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
          }, { once: true, capture: true });
        }
        parent = parent.parentElement;
      }
      
      // Update active state
      const allSwatches = cardWrapper.querySelectorAll('.card__color-swatch');
      allSwatches.forEach(s => s.classList.remove('card__color-swatch--active'));
      this.classList.add('card__color-swatch--active');
      
      // Update product image if variant has image
      const imageSrc = this.getAttribute('data-image-src');
      const imageSrcset = this.getAttribute('data-image-srcset');
      
      if (imageSrc && cardWrapper) {
        const mainImage = cardWrapper.querySelector('.card__media img');
        if (mainImage) {
          if (imageSrcset) {
            mainImage.setAttribute('srcset', imageSrcset);
          }
          mainImage.setAttribute('src', imageSrc);
        }
        
        // Also update secondary image if it exists
        const secondaryImage = cardWrapper.querySelector('.card__media img:nth-child(2)');
        if (secondaryImage && imageSrcset) {
          secondaryImage.setAttribute('srcset', imageSrcset);
          secondaryImage.setAttribute('src', imageSrc);
        }
      }
      
      // Update variant ID and selection in quick-add form
      const quickAddForm = cardWrapper.querySelector('.custom-product-form');
      if (quickAddForm) {
        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;
        
        try {
          const { variants, discontinuedMap } = getCollectionVariantData(quickAddForm);
          const colorValue = this.getAttribute('data-color-value');
          const selectedVariant = variants.find((v) => String(v.id) === String(variantId));

          const targetVariant =
            variants.find(
              (variant) =>
                variant.available &&
                !discontinuedMap[variant.id] &&
                (colorValue ? variant.options.includes(colorValue) : false)
            ) ||
            selectedVariant ||
            variants.find((variant) => variant.available && !discontinuedMap[variant.id]);

          if (!targetVariant) return;

          quickAddForm.dataset.selectedVariantId = String(targetVariant.id);
          selectCollectionVariantOptions(quickAddForm, targetVariant);
          updateCollectionAddButton(quickAddForm, targetVariant);
        } catch (err) {
          console.error('Error updating variant selection:', err);
        }
      }
      
      // Return false to prevent any default behavior
      return false;
    });
  });
}

// Initialize color swatches on page load and after dynamic content loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardColorSwatches);
} else {
  initializeCardColorSwatches();
}

// Re-initialize after AJAX content loads (for collection filtering, etc.)
document.addEventListener('shopify:section:load', () => {
  initializeCardColorSwatches();
  initializeVariantSelections();
});

// Price styles are now applied inline via Liquid, no JavaScript needed

// Apply rating color to star icon
function applyCardRatingStyles() {
  document.querySelectorAll('.rating').forEach(rating => {
    // Check if rating has inline color style (set by Liquid)
    if (rating.style.color) {
      const color = rating.style.color;
      const starIcon = rating.querySelector('.rating-star-icon');
      if (starIcon) {
        starIcon.style.color = color;
      }
    }
  });
}

// Set per-card --card-information-height so CSS can translateY(calc(100% - var(...))).
// Heights differ by title/rating/price; CSS alone cannot measure a child. Transform stays in custom.css.
function applyCardContentTransform() {
  document.querySelectorAll('.product-card-wrapper .card:not(.ratio) > .card__content').forEach(cardContent => {
    const cardInformation = cardContent.querySelector('.card__information--custom');
    if (cardInformation) {
      const height = cardInformation.offsetHeight;
      if (height > 0) {
        cardContent.style.setProperty('--card-information-height', `${height}px`);
      }
    }
  });
}

// Initialize all card styles on page load
function initializeCardStyles() {
  applyCardRatingStyles();
  applyCardContentTransform();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCardStyles);
} else {
  initializeCardStyles();
}

document.addEventListener('shopify:section:load', initializeCardStyles);

// Recalculate on resize
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyCardContentTransform();
  }, 100);
});

// Use capture phase to prevent parent link navigation when clicking color swatches
// This intercepts clicks on swatches before they reach parent links
document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.card__color-swatch');
  if (swatch && (e.target === swatch || swatch.contains(e.target))) {
    // Find any parent links and prevent their navigation
    let element = e.target;
    while (element && element !== document.body) {
      if (element.tagName === 'A' && element.href) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      element = element.parentElement;
    }
  }
}, true);

function initializeCartRecommendations() {
  document.querySelectorAll('.cart_recomm .custom-product-form').forEach((form) => {
    try {
      syncCollectionVariantForm(form);
    } catch (error) {
      console.error('Error initializing variants for form:', error);
    }
  });
}

function handleVariantChange(e) {
  const form = e.target.closest('.custom-product-form');
  if (!form) return;

  try {
    const { variants } = getCollectionVariantData(form);
    if (!variants.length) return;

    const selectedOptions = Array.from(form.querySelectorAll('fieldset')).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

    if (selectedOptions.some((value) => value == null)) {
      updateCollectionAddButton(form, null);
      return;
    }

    const matchingVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (!matchingVariant) {
      updateCollectionAddButton(form, null);
      return;
    }

    form.dataset.selectedVariantId = String(matchingVariant.id);
    updateCollectionAddButton(form, matchingVariant);
  } catch (error) {
    console.error('Error in handleVariantChange:', error);
  }
}

// Modify the cart_recomm function to use a more robust initialization approach
function cart_recomm() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !cartDrawer.productId) return;

  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes.length) continue;

      const recommendationsContainer = document.querySelector('.cart_recomm');
      if (!recommendationsContainer) continue;

      const productForms = recommendationsContainer.querySelectorAll('.custom-product-form');
      if (!productForms.length) continue;

      productForms.forEach((form) => {
        try {
          syncCollectionVariantForm(form);
        } catch (error) {
          console.error('Error initializing form:', error);
        }
      });

      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// ON DOCUMENT READY
$(() => {
  const initCollectionVariants = () => {
    collVariant();
    cart_recomm();
    initializeVariantSelections();
    initializeCardColorSwatches();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionVariants, { once: true });
  } else {
    initCollectionVariants();
  }

  // open header on hover starts
  $(window).width() > 990 && $(".header__inline-menu ul li header-menu").hover(
    function () { $(this).children(".mega-menu").attr("open", "true") },
    function () { $(this).children(".mega-menu").removeAttr("open") }
  );

  // Match mega menu content width to the top nav row (SHOP … WAREHOUSE SALE)
  const syncMegaMenuNavWidth = () => {
    const navList = document.querySelector('.header__inline-menu > .list-menu--inline');

    if (!navList || window.innerWidth < 990) {
      document.documentElement.style.removeProperty('--header-nav-width');
      return;
    }

    document.documentElement.style.setProperty(
      '--header-nav-width',
      `${Math.round(navList.getBoundingClientRect().width)}px`
    );
  };

  syncMegaMenuNavWidth();
  window.addEventListener('resize', syncMegaMenuNavWidth);
  document.addEventListener('shopify:section:load', syncMegaMenuNavWidth);
  document.addEventListener('shopify:section:reorder', syncMegaMenuNavWidth);
  
  $(document).on('change', '.custom-product-form input[type="radio"]', handleVariantChange);

  // Add event listeners for cart updates
  document.addEventListener('cart:updated', () => { setTimeout(cart_recomm, 100); });
  document.addEventListener('cart:refresh', () => { setTimeout(cart_recomm, 100); });
  document.addEventListener('cart:opened', () => { setTimeout(initializeCartRecommendations, 100); });
});